import {Module, PubSub} from '@mamdev/cad.static-next-lib';
import viewport from '../../ts/services/viewport';
import scrolling from '../../ts/services/scrolling';
import Tracking2 from '../../ts/services/tracking2';

export default class Homepage extends Module {
  private logoutPrompt: HTMLElement | null;
  private startCord = 0;

  // Init. from DOM.
  static attachTo(root: HTMLElement): Homepage {
    return new Homepage(root);
  }

  constructor(root: HTMLElement) {
    super(root);

    this.name_ = 'homepage';
    this.logoutPrompt = null;
  }

  // Start the module.
  start() {
    const homePageNode = this.root_.querySelector<HTMLElement>('[data-mod-name="channel"]');
    const lottoNode = this.root_.querySelector<HTMLElement>('[data-mod-name="lotto"]');
    const productsNode = this.root_.getElementsByClassName('productslider')[0] as HTMLElement;
    const overviewBlocks = this.root_.querySelectorAll('.overview__block[data-component-path], .teaser-stage[data-component-path], ui-region[data-component-path], .mod-tool[data-component-path]');

    Tracking2.bindTrackingExposeHandler(overviewBlocks);

    let homePageEndNode: HTMLElement | undefined = undefined;

    if (homePageNode) {
      this.startCord = viewport.getElementYOffset(homePageNode);
      homePageEndNode = homePageNode.lastElementChild as HTMLElement;
    }

    if (!homePageEndNode) this.log('No end node found!');

    scrolling.recalcScrollEnd(homePageEndNode, this.startCord);

    // observing lotto and products tool and send a tracking pixel if they are in the VP
    if (lottoNode) {
      scrolling.observeElement(function() {
        PubSub.publish('content:articleReadProgress', {
          click1: 'undefined',
          click2: 'undefined',
          click3: 'undefined',
          click4: 'undefined',
          clickname: 'scroll_lotto'
        });
      }).observe(lottoNode);
    }

    if (productsNode) {
      scrolling.observeElement(function() {
        PubSub.publish('content:articleReadProgress', {
          click1: 'undefined',
          click2: 'undefined',
          click3: 'undefined',
          click4: 'undefined',
          clickname: 'scroll_products'
        });
      }).observe(productsNode);
    }

    // Close to hide logout prompt
    this.logoutPrompt = this.root_.getElementsByClassName('logout')[0] as HTMLElement;

    if (this.logoutPrompt) {
      const closeBtn = this.logoutPrompt.getElementsByClassName('icon-close')[0];

      if (closeBtn) {
        closeBtn.addEventListener('click', e => {
          e.preventDefault();
          this.hideLogoutPromptBar();
        });
      }
    }

    this.subscribe('windowScrolling', () => {
      scrolling.handleScrollProgress(this.startCord, homePageEndNode);
    });

    this.subscribe('window:resize', () => {
      scrolling.recalcScrollEnd(homePageEndNode, this.startCord);
    });

    this.subscribe('layoutChanged', () => {
      scrolling.recalcScrollEnd(homePageEndNode, this.startCord);
    });
  }

  hideLogoutPromptBar() {
    if (this.logoutPrompt) {
      this.logoutPrompt.style.opacity = '0';

      setTimeout(() => {
        if (this.logoutPrompt) {
          this.logoutPrompt.style.display = 'none';
        }
      }, 300);
    }
  }
}
